import * as React from "react";
import type { SVGProps } from "react";
const SvgQuickbooksLogoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={264}
    height={264}
    fill="none"
    viewBox="0 0 264 264" {...props}
  >
    <path fill="#2CA01C" d="M0 0h264v264H0z" />
    <path
      fill="#fff"
      d="M53.002 132.11a42.78 42.78 0 0 0 42.778 42.778h6.11v-15.89h-6.11a26.888 26.888 0 0 1-10.356-51.793 26.9 26.9 0 0 1 10.356-1.985h14.666v83.112a15.89 15.89 0 0 0 15.888 15.89V89.332H95.78a42.78 42.78 0 0 0-42.778 42.778m116.11-42.778h-6.11v15.89h6.11a26.89 26.89 0 0 1 0 53.776h-14.666V75.89a15.9 15.9 0 0 0-4.653-11.236A15.9 15.9 0 0 0 138.558 60v114.89h30.554a42.78 42.78 0 0 0 30.248-12.53 42.775 42.775 0 0 0 0-60.497 42.78 42.78 0 0 0-30.248-12.53"
    />
  </svg>
);
export default SvgQuickbooksLogoIcon;
